import { useContext } from 'react'
import uniqid from 'uniqid'
import LaunchIcon from '@material-ui/icons/Launch'
import { ThemeContext } from '../../contexts/theme'
import './ProjectContainer.css'

const ProjectContainer = ({ project }) => {
  const [{ themeName }] = useContext(ThemeContext)

  return (
    <a href={project.livePreview} target="_blank" rel="noreferrer" className='project'>
      {project.image && (
        <span className='project__img'>
            <img src={project.image} alt={project.name} />
          </span>
      )}

      <span className="project__body">
      <h3
        className='project__title'
        style={{
          color: themeName === 'light' ? project.titleColorLight : project.titleColorDark
        }}
      >
        {project.name}
      </h3>

      <p className='project__description'>{project.description}</p>
        {project.stack && (
          <ul className='project__stack'>
            {project.stack.map((item) => (
              <li key={uniqid()} className='project__stack-item'>
                {item}
              </li>
            ))}
          </ul>
        )}

        {/* {project.sourceCode && (
        <a
          href={project.sourceCode}
          aria-label='source code'
          className='link link--icon'
        >
          <GitHubIcon />
        </a>
      )} */}

        {project.livePreview && (
          <span
            className='link link--icon'
          >
          <LaunchIcon />
        </span>
        )}
    </span>
    </a>
  )
}

export default ProjectContainer
